<div class="max-w-4xl mx-auto">
  <div class="bg-white rounded-lg shadow-md p-6">
    <h1 class="text-3xl font-bold text-slate-800 mb-6">
      Ausschreibungen
    </h1>

    <!-- File List -->
    <app-file-list
      [files]="files"
      [downloadPath]="downloadPath"
      [isLoading]="isLoading"
      [error]="error">
    </app-file-list>
  </div>
</div>
